import { all } from 'redux-saga/effects';
import auth from '../auth/sagas';
import profiles from '../profiles/sagas';
import clients from '../clients/sagas';
import contacts from '../contacts/sagas';
import tickets from '../tickets/sagas';
import users from '../users/sagas';
import agencies from '../agencies/sagas';
import companies from '../companies/sagas';
import dealers from '../dealers/sagas';
import dashboard from '../dashboard/sagas';

export default function* () {
    yield all([
        auth(),
        profiles(),
        tickets(),
        clients(),
        contacts(),
        users(),
        agencies(),
        companies(),
        dealers(),
        dashboard()
    ]);
}
